import BaselineHistory from '../components/BaselineHistory.vue';
import VerifyHistory from '../components/VerifyHistory.vue';
import VerifyHistoryDetail from '../components/VerifyHistoryDetail.vue';

export default [
  {
    path: '',
    redirect: 'baseline-history',
    role: ['User']
  },
  {
    path: 'baseline-history',
    component: BaselineHistory,
    meta: {
      title: 'Baseline History',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/polling-history',
          title: 'Polling History'
        },
        {
          path: '/polling-history/baseline-history',
          title: 'View Baseline History'
        }
      ]
    }
  },
  {
    path: 'verify-history',
    component: VerifyHistory,
    meta: {
      title: 'Verify History',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/polling-history',
          title: 'Polling History'
        },
        {
          path: '/polling-history/verify-history',
          title: 'View Verify History'
        }
      ]
    }
  },
  {
    path: 'verify-history/:id',
    component: VerifyHistoryDetail,
    meta: {
      title: 'Verify History Detail',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/polling-history/verify-history',
          title: 'Verify History'
        },
        {
          path: '',
          title: 'View Detail',
          isDisplayId: true
        }
      ]
    }
  }
];
